module.exports = __webpack_public_path__ + "img/icon_home_logo@3x.b8acae1e.png";